export enum LoginTypeEnum {
  Forbid = 'forbid',
  Login = 'login',
  RegisterAndLogin = 'register_and_login',
}
